



























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import { Action, Getter } from 'vuex-class';

@Component
export default class Accounting extends Vue {

    public yearAndMonthMenu: boolean = false;
    public tab: any = null;

    public formatRSD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'RSD' });
    public formatEUR = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' })

    @Watch('subject')
    @Watch('subjectName')
    @Watch('transactionType')
    @Watch('date')
    @Debounce(500)
    handleFilters() {
        /* this.fetchTransactions(); */
    }

    @Action('transactions/setSubject') setSubject: any;
    @Getter('transactions/subjects') subjects: any;
    @Getter('transactions/subject') subjectState: any;
    public get subject(): string {
        return this.subjectState;
    }

    public set subject(subject: string) {
        this.setSubject(subject);
    }

    @Action('transactions/setSubjectName') setSubjectName: any;
    @Getter('transactions/subjectName') subjectNameState: any;
    public get subjectName(): string {
        return this.subjectNameState;
    }

    public set subjectName(subjectName: string) {
        this.setSubjectName(subjectName);
    }

    @Action('transactions/setTransactionType') setTransactionType: any;
    @Getter('transactions/transactionTypes') transactionTypes: any;
    @Getter('transactions/transactionType') transactionTypeState: any;
    public get transactionType(): string {
        return this.transactionTypeState;
    }

    public set transactionType(transactionType: string) {
        this.setTransactionType(transactionType);
    }

    @Action('transactions/setDate') setDate: any;
    @Getter('transactions/date') dateState: any;
    public get date(): string {
        return this.dateState;
    }

    public set date(date: string) {
        this.setDate(date);
    }

    @Action('transactions/fetchTransactionsReport') fetchTransactionsReport: any;
    @Getter('transactions/transactionsReport') transactionsReport: any;

    @Action('transactions/setTransactionsLoading') setTransactionsLoading: any;
    @Getter('transactions/transactionsLoading') transactionsLoadingState: any;
    
    public get transactionsLoading(): boolean {
        return this.transactionsLoadingState;
    }

    public set transactionsLoading(value: boolean) {
        this.setTransactionsLoading(value);
    }

    @Action('transactions/clearPayload') clearFilters: any;
    @Getter('transactions/payload') payload: any;

    public customSum(r: any[], a: any[]) {
        return r.map((b: number,i: number) => a[i] + b);
    }

    public formatFamilyTotalPerMonth(data: any): any[]
    {
        let monthlyData = [];

        for (const family in data) {
            let transactions = data[family];
            monthlyData.push(this.formatFamilyTransactionsAmountPerMonth(transactions));
        }

        return monthlyData.reduce(this.customSum);
    }

    public formatBabysitterTotalPerMonth(data: any): any[]
    {
        let monthlyData = [];

        for (const babysitter in data) {
            let transactions = data[babysitter];
            monthlyData.push(this.formatBabysitterTransactionsAmountPerMonth(transactions));
        }

        return monthlyData.reduce(this.customSum);
    }

    public formatFamilyTransactionsAmountPerMonth(monthlyData: any): any[]
    {   
        let amountPerMonth = [];
        
        for (const day in monthlyData) {
            
            let transactions = monthlyData[day];
            amountPerMonth.push(this.formatFamilyTransactionsAmount(transactions));
            
        }

        return amountPerMonth.reduce(this.customSum);
    }

    public formatBabysitterTransactionsAmountPerMonth(monthlyData: any): any[]
    {   
        let amountPerMonth = [];
        
        for (const day in monthlyData) {
            
            let transactions = monthlyData[day];
            amountPerMonth.push(this.formatBabysitterTransactionsAmount(transactions));
            
        }

        return amountPerMonth.reduce(this.customSum);
    }

    

    public transactableName(transaction: any): string
    {
        switch (transaction.transactable_type) {
            case 'babysitting_session': return `Session #${transaction.transactable_id}`;
            case 'balance_package': return `Balance Package - ${transaction.transactable.name}`;
            default: return '/';
        }
    }

    public formatTransactionAmount(transaction: any): string
    {
        if ( transaction.subjectable_type == 'family' ) {
            return this.calculateFamilyTransaction(transaction);
        } 

        return this.calculateBabysitterTransaction(transaction);
    }

    public formatFamilyTransactionsAmount(transactions: any): any[]
    {
        const credits = transactions.filter((transaction:any) => transaction.type == 1);

        const debits = transactions.filter((transaction:any) => transaction.type == 2);

        let totalCredits = credits.reduce((a:any, b:any) => a + b.hours, 0);
        let totalDebits = debits.reduce((a:any, b:any) => a + b.hours, 0);

        /* return { 
            totalCredits: totalCredits,
            totalDebits: totalDebits
        }; */
        return [ totalCredits, totalDebits ];
    }

    public formatBabysitterTransactionsAmount(transactions: any): any[]
    {
        const credits = transactions.filter((transaction:any) => transaction.type == 1);

        const debits = transactions.filter((transaction:any) => transaction.type == 2);

        let totalCredits = credits.reduce((a:any, b:any) => a + b.amount, 0);
        let totalDebits = debits.reduce((a:any, b:any) => a + b.amount, 0);

        /* return { 
            totalCredits: totalCredits / 100,
            totalDebits: totalDebits / 100
        }; */
        return [ totalCredits, totalDebits ];
    }

    public calculateFamilyTransaction(transaction: any): string
    {
        const hours = transaction.hours;
        return transaction.type == 1 ? `+${hours}` : `-${hours}`;
    }

    public formatFamilyAmount(amounts: any[]): string
    {
        const credits = (Math.round(amounts[0] * 100) / 100).toFixed(2)
        const debits = (Math.round(amounts[1] * 100) / 100).toFixed(2)

        return `( +${credits} ) ( -${debits} )`
    }

    public formatBabysitterAmount(amounts: any[]): string
    {
        const credits = amounts[0] / 100;
        const debits = amounts[1] / 100;

        return `( + ${this.formatRSD.format(credits)} ) ( - ${this.formatRSD.format(debits)} )`
    }

    public calculateBabysitterTransaction(transaction: any): string
    {
        const result = transaction.amount / 100;

        return transaction.type == 1 ? `+ ${this.formatRSD.format(result)}` : `- ${this.formatRSD.format(result)}`;
    }
}
